import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@sr/ui-library';
import { Control } from 'react-hook-form';
import {
  addressGroupRequiredString,
  requiredNonBlankString,
} from '../../shared/countryAwareStringSchema';
import { WORKSPACE_DETAILS_FORM_FIELDS } from '../../shared/fieldNames';
import { WorkspaceDetailsFormValues } from '../../shared/types';

interface AddressLineFieldProps {
  control: Control<WorkspaceDetailsFormValues>;
}

/**
 * Street address (DTO line1). Legacy parity:
 * components/WorkspaceDetails/AddressDetails/AddressDetailsForm.tsx:172-181.
 */
export const AddressLineField = ({ control }: AddressLineFieldProps) => (
  <FormField
    name={WORKSPACE_DETAILS_FORM_FIELDS.addressLine1}
    control={control}
    render={({ field }) => (
      <FormItem>
        <FormLabel asterisk>Address</FormLabel>
        <FormControl>
          <Input {...field} placeholder="Apartment, Street Address, etc" />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);

AddressLineField.schema = addressGroupRequiredString(
  WORKSPACE_DETAILS_FORM_FIELDS.addressLine1,
  (schema) => requiredNonBlankString('Address', schema),
);
